/**
 * po列表
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2021/4/13      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React from "react";
import CommonBreadcrumb from "../../../components/CommonBreadcrumb";
import Statistics from "../components/Statistics";
import { Form, DatePicker, Input, Pagination, Empty,Spin,Tooltip } from "antd";
import "./index.less";
import Lang from "../../../components/Lang/Lang";
import BigPo from "../components/BigPo/index";
import OrderStatus from "../components/OrderStatus";
import dayjs from "dayjs";
import qs from "query-string";
import { Link } from "react-router-dom";
const { RangePicker } = DatePicker;
const { Search } = Input;
class Po extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            countLoading: false,
            model: {},
            //加载中
            loading: true,
            //数据源
            list: [],
            pageSize: 50,
            pageIndex: 1,
            total: 0,
            extra: {},
        };
        this.params = {
            id: (qs.parse(props.location.search) || {}).id,
        };
    }

    /**
     * 获取数据
     **/
    getData(pageIndex, pageSize) {
        this.setState(
            {
                loading: true,
            },
            () => {
                let postData = {
                    buyerId: this.params.id,
                    pagingQuery: {
                        pageIndex: pageIndex || this.state.pageIndex,
                        pageSize: pageSize || this.state.pageSize,
                    },
                };

                if (this.params.startTime) {
                    postData.startTime = this.params.startTime;
                }
                if (this.params.endTime) {
                    postData.endTime = this.params.endTime;
                }

                if (this.params.keyword) {
                    postData.keyword = this.params.keyword;
                }

                //"0"即为查询全部
                if (
                    this.params.status !== undefined &&
                    this.params.status !== "-1"
                ) {
                    postData.status = this.params.status;
                }

                $.ajax({
                    url: "/mg/po/essa-one/po-list",
                    type: "post",
                    dataType: "json",
                    contentType: "application/json",
                    data: JSON.stringify(postData),
                    success: (res) => {
                        let data = {
                            loading: false,
                        };
                        if (res.success && res.valid) {
                            data = Object.assign(data, {
                                list: res.models || [],
                                extra: res.extra || {},
                            });
                        }
                        //分页
                        if (res.paging) {
                            data = Object.assign(data, {
                                pageIndex: res.paging.pageNum,
                                pageSize: res.paging.pageSize,
                                total: res.paging.total,
                            });
                        }
                        this.setState(data);
                    },
                    error: () => {
                        let data = {
                            loading: false,
                        };
                        this.setState(data);
                    },
                });
            }
        );
    }

    /**
     * 获取统计数据
     **/
    getCount() {
        this.setState(
            {
                countLoading: true,
            },
            () => {
                let postData = {
                    id: this.params.id,
                };
                $.ajax({
                    url: "/service/mg/statistics/po/data",
                    type: "post",
                    dataType: "json",
                    contentType: "application/json",
                    data: JSON.stringify(postData),
                    success: (res) => {
                        let data = {
                            countLoading: false,
                        };
                        if (res.success && res.valid) {
                            data = Object.assign(data, {
                                model: res.model||{},
                            });
                        }
                        this.setState(data);
                    },
                    error: () => {
                        let data = {
                            countLoading: false,
                        };
                        this.setState(data);
                    },
                });
            }
        );
    }

    /**
     * 搜索
     * @params value 关键字
     **/
    onSearch = (value) => {
        this.params.keyword = value;
        this.getData(1);
    };

    /**
     * 订单状态切换
     */
    orderStatusHandleChange = (value) => {
        this.params.status = value;
        this.getData(1);
    };

    /**
     * 时间回调
     */
    onTimeChange = (dates, dateStrings) => {
        this.params.startTime = dates[0].format("YYYY/MM/DD");
        this.params.startTime = dayjs(this.params.startTime).format("x");
        this.params.endTime = dates[1].format("YYYY/MM/DD");
        this.params.endTime = dayjs(this.params.endTime).format("x");
        this.params.endTime = String(parseInt(this.params.endTime) + 86399000);
        this.getData(1);
    };

    /**
     * 切换分页
     * @param page 切换到第几页
     * @param pageSize
     **/
    onChangePage = (page, pageSize) => {
        this.getData(page, pageSize);
    };

    /**
     * 获取理赔详情
     * */
    getPayMoney(currencySymbol='',arriveLatePayAmount=0){
        const m = Math.round(arriveLatePayAmount * 100) / 100;
        return m > 0 ? currencySymbol+''+m: 0;
    }
    componentDidMount() {
        this.getData();
        this.getCount();
    }

    render() {
        let _this = this;
        let { model, list, loading, extra } = this.state;
        let state = this.state;
        return (
            <div>
                <CommonBreadcrumb
                    list={[{ name:__getServerLanguage('CaiGouShangHangWeiShuJu'),link:'/dataStatistics/behavior'},{ name: __getServerLanguage("PoDanLieBiao") }]}
                ></CommonBreadcrumb>
                <div className="main-wrap po-wrap">
                    {/*头部*/}
                    <div className="title-wrap">
                        <span className="title">
                            {__getServerLanguage("DingDan")}
                        </span>
                        <Link className="num" to={`/customer/detail?id=${extra.buyerId}`}>{extra.buyerCode}</Link>
                    </div>

                    <Spin spinning={loading}>
                        {/*统计*/}
                        <Statistics model={model}></Statistics>

                        {/*操作栏*/}
                        <div className="option-wrap">
                            <Form layout="inline">
                                <Form.Item
                                    label={<Lang id="XiaDanShiJian">下单时间</Lang>}
                                >
                                    <RangePicker
                                        style={{ width: "100%" }}
                                        placeholder={[
                                            Lang({
                                                id: "KaiShiShiJian",
                                                default: "开始时间",
                                            }),
                                            Lang({
                                                id: "JieShuShiJian",
                                                default: "结束时间",
                                            }),
                                        ]}
                                        onChange={this.onTimeChange}
                                    />
                                </Form.Item>
                                <Form.Item>
                                    {/*订单状态*/}
                                    <OrderStatus
                                        status={this.params.status}
                                        handleChange={this.orderStatusHandleChange}
                                    ></OrderStatus>
                                </Form.Item>
                                <Form.Item>
                                    <Search
                                        placeholder={__getServerLanguage("QingShuRuDingDanBianMaHuoShangPinBianMa")}
                                        allowClear
                                        onSearch={this.onSearch}
                                        style={{ width: 350 }}
                                    />
                                </Form.Item>
                            </Form>
                        </div>

                        {/*列表*/}
                        {list.map(function (item, index) {
                            return (
                                <BigPo
                                    key={index}
                                    nowTime={extra.now}
                                    model={item}
                                    index={index}
                                    callBack={_this.getData.bind(_this)}
                                ></BigPo>
                            );
                        })}

                        {/*列表为空*/}
                        {!loading && list.length < 1 ? (
                            <Empty
                                description={__getServerLanguage(
                                    "WeiZhaoDaoFuHeTiaoJianDeDingDan"
                                )}
                            />
                        ) : null}

                        {/*分页*/}
                        <div
                            className="margin-top-20"
                            style={{ display: list.length > 0 ? "block" : "none" }}
                        >
                            <Pagination
                                showTotal={total => (
                                    `Total ${extra.poTotalNum||0} items`
                                )}
                                showQuickJumper
                                current={state.pageIndex || 1}
                                defaultPageSize={state.pageSize || 50}
                                defaultCurrent={state.pageIndex || 1}
                                total={state.total || 0}
                                onChange={this.onChangePage.bind(this)}
                            />
                        </div>
                    </Spin>
                </div>
            </div>
        );
    }
}

Po.defaultProps = {};

Po.propTypes = {};
export default Po;
